import request from "@/plugins/request"

// 获取首页商品分类列表
export const getCategoryList = (params) => {
  return request({
    url: "app-api/product/category/list",
    method: "get",
    params,
  })
}

// 获取商品列表
export const getProductList = (params) => {
  return request({
    url: "app-api/product/spu/page",
    method: "get",
    params,
  })
}

// 获取商品详情
export const getProductDetail = (params) => {
  return request({
    url: "app-api/product/spu/get-detail",
    method: "get",
    params,
  })
}

// 出行地列表
export const getPlaceList = (params) => {
  return request(
    {
      url: "app-api/product/spu/placeList",
      method: "get",
      params,
    },
    { showLoading: false },
  )
}

// 获取购物车列表
export const getCartList = (params) => {
  return request({
    url: "app-api/trade/cart/list",
    method: "get",
    params,
  })
}

// 添加购物车
export const cartAdd = (data) => {
  return request(
    {
      url: "app-api/trade/cart/add",
      method: "post",
      data,
    },
    { hideLoading: true },
  )
}

// 更新购物车
export const cartUpdate = (data) => {
  return request({
    url: "app-api/trade/cart/update-count",
    method: "put",
    data,
  })
}
// 更新购物车
export const cartDel = (data) => {
  return request({
    url: "app-api/trade/cart/delete",
    method: "delete",
    params: data,
  })
}

// 获取商品评价
export const getProductReview = (params) => {
  return request({
    url: "app-api/product/comment/page",
    method: "get",
    params,
  })
}

// 未登录获取优惠券
export const getNewReward = (params) => {
  return request({
    url: "app-api/promotion/coupon/getNewReward",
    method: "get",
    params,
  })
}

// 获取地址国家列表
export const getAddressCountryList = (params) => {
  return request({
    url: "app-api/zb/configCity/country",
    method: "get",
    params,
  })
}

// 获取城市
export const getCityList = (params) => {
  return request({
    url: "app-api/zb/configCity/cityList",
    method: "get",
    params,
  })
}